<template>
  <div>
    <section>
      <!-- Content -->
      <div id="container" v-if="loadedComponent">
        <!-- Calendar -->
        <div class="calendar">
          <div
            class="current-day"
            onclick="document.getElementById('datetime').click();"
          >
            <button class="btn btn-calendar collapsed">
              <i class="fas fa-calendar-alt"></i>
              <span>{{ !filter.date ? "Hoje" : "Data" }}:</span>
              {{ actualDate }}
            </button>

            <div class="clearfix"></div>
          </div>
        </div>

        <!-- Main Content -->
        <div class="main-content">
          <div class="row">
            <div class="col-6">
              <div class="form-group" id="select">
                <select
                  class="form-control"
                  id="select1"
                  v-model="filter.order_type"
                  @change="bringData"
                >
                  <option value="0">Filtrar tipo de serviço</option>
                  <option
                    v-for="option in order_types"
                    :key="option.id"
                    :value="option.id"
                  >
                    {{ option.type_name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group" id="select">
                <select
                  class="form-control"
                  id="select1"
                  v-model="filter.status"
                  @change="bringData"
                >
                  <option value="0">Filtrar status</option>
                  <option value="2">Visita Confirmada</option>
                  <option value="3">À Confirmar</option>
                  <option value="4">Em Atendimento</option>
                  <option value="5">Finalizada</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Client -->
            <div class="col-md-4" v-for="demand in demands" :key="demand.id">
              <div
                :class="
                  demand.status == 2
                    ? 'card tag-confirmed'
                    : demand.status == 4
                    ? 'card tag-checkin'
                    : demand.status == 5
                    ? 'card tag-finished'
                    : 'card tag'
                "
              >
                <div class="card-header">
                  <div class="row">
                    <div class="col-8">
                      <div class="client-name more-text">
                        <span
                          style="
                            text-transform: uppercase;
                            font-size: 16px;
                            font-weight: bold;
                          "
                          >{{ demand.order_type.type_name }}</span
                        ><br />
                        {{ demand.customer.name }}
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="client-time">{{ demand.hour }}h</div>
                      <br />
                      <div class="client-time">{{ demand.date }}</div>
                    </div>
                  </div>
                </div>
                <div class="card-body" @click="view(demand.id)">
                  <div class="row">
                    <div class="col-12">
                      <div class="id_demand"># {{ demand.id }}</div>
                      <div class="info-client">
                        <!-- <i class="fas fa-map-marker-alt"></i> -->
                        {{ demand.customer.address }} -
                        {{ demand.customer.city }} -
                        {{ demand.customer.state }}
                      </div>
                      <div class="info-client" v-if="demand.customer.telephone">
                        <!-- <i class="fas fa-mobile-alt"></i> -->
                        {{ demand.customer.telephone }}
                      </div>
                      <div
                        class="info-client"
                        style="margin-bottom: 5px; margin-top: 15px"
                      >
                        <!-- <i class="fas fa-info-circle"></i> -->
                        {{
                          demand.status == 2
                            ? "Visita Confirmada"
                            : demand.status == 4
                            ? "Em Atendimento"
                            : demand.status == 5
                            ? "Finalizada"
                            : "À Confirmar"
                        }}
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="client-button">
                        <!-- <a class="map-client" href="map.html">
                          Ver Mapa
                          <i class="fas fa-map"></i>
                        </a>-->
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="demands.length == 0"
              style="padding: 35px; text-align: center; font-size: 16px"
              class="col-md-12"
            >
              Não há atendimentos atribuídos para você neste momento.
            </div>
          </div>
        </div>
      </div>
    </section>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>

    <datetime
      v-model="filter.date"
      :phrases="{ ok: 'Ok', cancel: 'Cancelar' }"
      value-zone="America/Sao_Paulo"
      zone="America/Sao_Paulo"
      input-style="display:none;"
      input-id="datetime"
      type="date"
      v-on:input="bringData"
    ></datetime>
  </div>
</template>

<script>
import CtkDateTimePicker from "vue-ctk-date-time-picker";
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      filter: {
        order_type: 0,
        status: 0,
      },
      demands: [],
      order_types: [],
      isLoading: true,
      fullPage: true,
      loadedComponent: false,
      actualDate: moment().format("LL"),
    };
  },
  computed: {},
  methods: {
    bringData: function () {
      const self = this;
      const api = self.$store.state.api + "my-demands";

      self.loadedComponent = false;
      self.isLoading = true;

      if (self.filter.date) {
        self.actualDate = moment(self.filter.date).format("LL");
      }

      self.$http
        .post(api, self.filter)
        .then((response) => {
          self.demands = response.data;
          self.loadedComponent = true;
          self.isLoading = false;
          self.getWorkOrderTypes();
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },

    getWorkOrderTypes: function () {
      const self = this;
      const api = self.$store.state.api + "work_order_types";

      self.$http
        .get(api)
        .then((response) => {
          self.order_types = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    view(id) {
      this.$router.push("/view/" + id);
    },
  },
  components: { CtkDateTimePicker, Loading },
  props: {},
  mounted: function () {
    this.bringData();
  },
};
</script>
<style scoped>
/* min-width */
@media screen and (min-width: 900px) {
  .margin-home {
    margin-top: -20px;
  }
}

.tag {
  /* background-color: #eee; */

  border-left-color: #666;
  border-left-width: 10px;
  border-left-style: solid;
}

.tag-confirmed {
  /* background-color: rgb(27, 206, 0); */

  border-left-color: rgb(255, 183, 0);
  border-left-width: 10px;
  border-left-style: solid;
}

.tag-finished {
  /* background-color: rgb(27, 206, 0); */

  border-left-color: rgb(27, 206, 0);
  border-left-width: 10px;
  border-left-style: solid;
}

.tag-checkin {
  /* background-color: rgb(100, 152, 255); */

  border-left-color: rgb(100, 152, 255);
  border-left-width: 10px;
  border-left-style: solid;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue